export default __webpack_public_path__ + "3aad51b5edd69a8eca4b6f0c4a5cf3b6.png";